<template>
    <div>
        <template v-if="useRouter && account && isSuper">
            <b-link
                v-if="transactionType == 'STRIPE'"
                :href="stripeUrl"
                :target="openNew ? '_blank' : '_self'"
                >{{ transactionId }}</b-link
            >
            <b-link
                v-else-if="transactionType == 'CCONNECT'"
                :href="cardConnectUrl"
                :target="openNew ? '_blank' : '_self'"
                >{{ transactionId }}</b-link
            >
        </template>
        <span v-else>
            {{ transactionId }}
        </span>
    </div>
</template>

<script>
/**
 * @module TransactionIdLink
 * @description Display Transaction ID as a link
 */
export default {
    name: "transactionIdLink",
    props: {
        transactionId: {
            type: String,
            default: null
        },
        transactionType: {
            type: String,
            default: null
        },
        /**
         * useRouter: true = use react router push, false = use native anchor href
         */
        useRouter: {
            type: Boolean,
            default: true
        },
        account: {
            type: String,
            default: null
        },
        openNew: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isSuper() {
            return this.$root.currentActor.issuper;
        },
        stripeUrl() {
            const stripeBaseUrl = process.env.STRIPE_URL;
            const accountPath = this.account;
            const transactionId = this.transactionId;

            if (process.env.VUE_APP_ENV !== "PROD") {
                return `${stripeBaseUrl}${accountPath}/test/payments/${transactionId}`; // FOR LOCAL OR QA
            }
            return `${stripeBaseUrl}${accountPath}/payments/${transactionId}`; // FOR PRODUCTION ONLY
        },
        cardConnectUrl() {
            const cardConnectProdUrl = process.env.CCONNECT_PROD_URL;
            const cardConnectUatUrl = process.env.CCONNECT_UAT_URL;
            const accountPath = this.account;
            const transactionId = this.transactionId;

            if (process.env.VUE_APP_ENV != "PROD") {
                return `${cardConnectUatUrl}account/#/reporting/transactiondetail/${accountPath}/R${transactionId}`; // FOR LOCAL OR QA
            }
            return `${cardConnectProdUrl}account/#/reporting/transactiondetail/${accountPath}/R${transactionId}`; // FOR PRODUCTION ONLY
        }
    }
};
</script>
